export default "__VITE_ASSET__BK$JKdjX__"